// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"k8-z","displaySixCardTiles":"l8-z"};